<template>
  <parent>
    <div class="container m-auto">
      <div class="mb-2">
        <b-button
          variant="icon-light"
          class="shadow"
          @click="$router.push({ name: 'monitoring' })"
        >
          <GjIcon name="ArrowLeft" />
          Back
        </b-button>
      </div>
      <b-card class="text-center">
        <b-tabs
          v-model="tabIndex"
          nav-class="mb-2"
        >
          <b-tab
            title="Overview"
            active
          >
            <paper-simple v-if="gettingHost">
              <loading-page />
            </paper-simple>
            <overview
              v-else
              :host="host"
            />
          </b-tab>
          <b-tab title="Metrics">
            <div>
              <sidebar @activeTab="changeActiveTab" />
              <div
                v-if="tabIndex === 1"
                :key="layout"
                class="w-100"
              >
                <paper-simple v-if="gettingHost">
                  <loading-page />
                </paper-simple>
                <template v-else>
                  <component
                    :is="layout"
                    :host="host"
                  />
                </template>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </parent>
</template>
<script>
import { BCard, BTab, BTabs } from 'bootstrap-vue'
import redirectError from '@/services/redirectError'
import Paper from '@/components/paper/Paper.vue'
import Sidebar from './parts/Sidebar.vue'
import Overview from './parts/Overview.vue'

const MetricsOverview = () => import('./parts/MetricsOverview.vue')
const Cpu = () => import('./parts/Cpu.vue')
const Network = () => import('./parts/Network.vue')
const Memory = () => import('./parts/Memory.vue')
const FileSystem = () => import('./parts/FileSystem.vue')

export default {
  name: 'HostDetails',
  components: {
    Paper,
    Sidebar,
    Overview,
    Cpu,
    Network,
    Memory,
    MetricsOverview,
    FileSystem,
    BCard,
    BTab,
    BTabs,
  },
  data() {
    return {
      id: null,
      activeTab: 0,
      tabIndex: 0,
    }
  },
  computed: {
    gettingHost() {
      return this.$store.state.observability.gettingHost
    },
    gettingHostNetwork() {
      return this.$store.state.observability.gettingHostNetwork
    },
    gettingHostMemory() {
      return this.$store.state.observability.gettingHostMemory
    },
    gettingHostCpu() {
      return this.$store.state.observability.gettingHostCpu
    },
    host() {
      return this.$store.state.observability.host
    },
    layout() {
      if (this.activeTab === 1) {
        return 'cpu'
      }
      if (this.activeTab === 2) {
        return 'network'
      }
      if (this.activeTab === 3) {
        return 'memory'
      }
      if (this.activeTab === 4) {
        return 'file-system'
      }
      return 'metrics-overview'
    },
  },
  created() {
    this.id = this.$route.params.id

    this.$store.dispatch('observability/getHost', this.id).catch(error => {
      if (error.response?.status === 403) {
        this.hasHostPermission = false
        return
      }
      redirectError(error)
      this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while getting host.')
    })
    this.$store
      .dispatch('observability/getNetworkInterfaces', this.id)
      .catch(error => {
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching network interfaces.',
        )
      })
  },
  methods: {
    changeActiveTab(val) {
      this.activeTab = val
    },
  },
}
</script>

<style lang="scss" scoped>
.card-info::v-deep {
  .card-body {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
}
</style>
